import gql from 'graphql-tag';

export const gqlGet = gql`
  query getCollectionpoints($where: String, $limit: Int) {
    getCollectionpoints(where: $where, limit: $limit) {
      data {
        id
        name
        addressDescription
        addressLine1
        addressCity
        postalCode
        profession {
          id
          name
        }
        latitude
        longitude
      }
      recordCount
    }
  }
`;

export const gqlGet00 = gql`
  query getCollectionpointGeocoding($where: String, $limit: Int) {
    getCollectionpointGeocoding(where: $where, limit: $limit) {
      data {
        latitude
        longitude
        collectionpoint {
          id
          name
          addressLine1
          addressCity
          postalCode
          profession {
            id
            name
          }
        }
      }
    }
  }
`;

export const gqlGetAggr = gql`
  query getCollectionpointGeocodingAggr(
    $grouping: String
    $fromLat: Float
    $tillLat: Float
    $fromLon: Float
    $tillLon: Float
  ) {
    getCollectionpointGeocodingAggr(
      grouping: $grouping
      fromLat: $fromLat
      tillLat: $tillLat
      fromLon: $fromLon
      tillLon: $tillLon
    ) {
      name
      value
      latitude
      longitude
    }
  }
`;
